import { useCallback, useEffect, useRef, useState } from "react";
import apiClient from "../../components/utils/apiClient";
import RequestsTable from "../../components/requests/RequestsTable";
import RequestCard from "../../components/requests/RequestCard";
import { getApp, getApps, initializeApp } from "firebase/app";
import {getDatabase, onChildAdded, onChildChanged, onChildRemoved, push, ref} from "firebase/database";
import { firebaseConfig } from "../../components/utils/constants";
import { useTranslation } from "react-i18next";
import useThrottledFetch from "../../hooks/useThrottledFetch";

const ActiveRequests = ({vendorId,setIsActionLoading}) => {
    const {t} = useTranslation();

    const [requests, setRequests] = useState(null);
    const [requestsIds, setRequestsIds] = useState(null);

    const hasInitializedIdsRef = useRef(false);
    useEffect(() => { hasInitializedIdsRef.current = false; }, [vendorId]);

    const requestsIdsRef = useRef(null);
    useEffect(() => { requestsIdsRef.current = requestsIds; }, [requestsIds]);

    let FireBasePath = null;

    if(process.env.REACT_APP_API_URL === 'https://beta-production-api.fanni.site') {
      FireBasePath = 'vendor-requests';
    } else {
      FireBasePath = 'dev/vendor-requests';
    }

    const getRequests = useCallback(async () => {
        try {
          const response = await apiClient.get(`/requests/vendor-requests?skip=0&vendorsId=${vendorId}&statuses=active,postponed`);
          if(response?.data) {
            setRequests(response?.data);
            if(!hasInitializedIdsRef.current) {
              hasInitializedIdsRef.current = true;
              setRequestsIds(response?.data?.map(request=>request?.requestPrettyId));
            }
          }
          setIsActionLoading(false);
        } catch(err) {setIsActionLoading(false);}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vendorId]);

    const { enqueue } = useThrottledFetch(getRequests, {
      intervalMs: 5000,
      enabled: !!vendorId,
    });

    useEffect(()=>{
        setIsActionLoading(true);
    },[])

    useEffect(()=>{
      if(vendorId) {
        getRequests();
      }
    },[vendorId])


    useEffect(()=>{
        if(!FireBasePath || !requestsIds || !vendorId) return;
        const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
        const db = getDatabase(app);
        const activeRequestsRef = ref(db, `${FireBasePath}/${vendorId}/active`);
        const unSubscribeActive = onChildAdded(activeRequestsRef, (snapshot) => {
            const data = snapshot.key;
            if(data && !requestsIdsRef.current?.includes(data)) {
              enqueue();
            }
        });

        const unSubscribeRemoveActive = onChildRemoved(activeRequestsRef, (snapshot) => {
            const data = snapshot.key;
            if(data) {
              enqueue();
            }
        });

        return()=>{
            unSubscribeActive();
            unSubscribeRemoveActive();
        }
    },[FireBasePath,requestsIds,vendorId,enqueue])


    useEffect(()=>{
        if(!FireBasePath || !vendorId) return;
        const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
        const db = getDatabase(app);
        const activeRequestsRef = ref(db, `${FireBasePath}/${vendorId}/active`);
        const unSubscribeChangedActive = onChildChanged(activeRequestsRef, (snapshot) => {
            const data = snapshot.key;
            if(data) {
              enqueue();
            }
        });

        return()=>{
            unSubscribeChangedActive();
        }
    },[FireBasePath,vendorId,enqueue])


    return (
        <>
        {requests && <div className="flex flex-wrap gap-[16px] mt-[24px]">
          { Array.isArray(requests) && requests?.length > 0 ? requests?.map((request,index)=>{
            return <RequestCard key={`new-request-${index}`} request={request} />
          }) : <div className="text-center w-full max-w-[500px] mx-auto pt-[156px] font-[500] text-[24px] text-grey-900">
            <img src="/assets/images/no-requests.svg" alt="" className="w-[188px] h-[188px] mb-[24px] mx-auto" />
            {t('requests.noActiveRequests')}
            </div>
          }
        </div>}
        </>);
}
export default ActiveRequests;
